import { WecomConversationDataType } from "../../types";
import EventBus from "../event-bus";
const conversationChangeHook = new EventBus<WecomConversationDataType>(
  "conversationChangeHook"
);

export default conversationChangeHook;
